// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UserMenu_wrapper__2ZhOY","text":"UserMenu_text__2GxtO","btn":"UserMenu_btn__kOiSP"};